import { render } from "./addGroupDialog.vue?vue&type=template&id=c9f5cb5e"
import script from "./addGroupDialog.vue?vue&type=script&lang=js"
export * from "./addGroupDialog.vue?vue&type=script&lang=js"

import "./addGroupDialog.vue?vue&type=style&index=0&id=c9f5cb5e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__